import type { FC } from "react";

import type { RedirectionLinkCardProps } from "@ui/components/RedirectionLinkCard";

import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import { HeaderNavListItem } from "../../../MobileNavigation/components/HeaderNavListItem";

import styles from "./List.module.scss";

export type ListProps = {
  items: RedirectionLinkCardProps[];
};

export const List: FC<ListProps> = ({ items }) => {
  return (
    <ul className={styles.list}>
      {items?.map(({ title, link }) => {
        const dispatchGTMEvent = () => {
          dispatchTrackingEvent(TrackingEvents.TrackingMenuNavigationClick, { menu_link: title });
        };

        return (
          <li key={title} className={styles.item}>
            <HeaderNavListItem variant="link" label={title} href={link ?? ""} onClick={dispatchGTMEvent} />
          </li>
        );
      })}
    </ul>
  );
};
